import * as jsYaml from 'js-yaml';

export { jsYaml };
